import React, { useMemo } from 'react';
import {
  createSearchParams, NavLink, useLocation, useNavigate,
} from 'react-router-dom';
import { AnyObject } from '@triare/auth-redux';
import {
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Menu as AntdMenu } from 'antd';
import { connect } from 'react-redux';
import { signOut } from '@triare/auth-redux/dist/saga/auth/signOut';
import { Route } from '../../../routes';
import store, { RootState } from '../../../store';
import { moduleName, useAuth, User } from '../../../store/auth';
import { useSimpleModal } from '../../Common/Modal/Simple';
import { doesUserHaveAccess } from '../../../routes/PrivateRoute';
import SignIn from '../../../pages/Auth/SignIn';
import ForgotPassword from '../../../pages/Auth/ForgotPassword';
import ResetPassword from '../../../pages/Auth/ResetPassword';
import SignUp from '../../../pages/Auth/SignUp';
import Information from '../../../pages/Auth/SignUp/Information';
import ConfirmEmail from '../../../pages/Auth/ConfirmEmail';
// import Chat from '../../../pages/Chat';

import styles from './index.module.scss';
import Bookmarks from '../../../pages/Bookmarks';
import Products from '../../../pages/Products';
import SearchResults from '../../../pages/SearchResults';
import Category from '../../../pages/Category';
import SubCategory from '../../../pages/SubCategory';
import Article from '../../../pages/Article';
import AutoLogin from '../../Pages/Auth/SignIn/AutoLogin';

export interface MenuRoute extends Route {
  ignoreMenu?: boolean;

  children?: MenuRoute[];
}

export const routes: MenuRoute[] = [
  {
    name: 'Sign In',
    align: 'left',
    route: {
      path: 'sign-in',
      element: <SignIn />,
    },
  },
  // {
  //   name: 'Sign Up',
  //   align: 'left',
  //   route: {
  //     path: 'sign-up',
  //     element: <SignUp />,
  //   },
  //   children: [
  //     {
  //       name: 'Information',
  //       route: {
  //         path: 'information',
  //         element: <Information />,
  //       },
  //     },
  //   ],
  // },
  // {
  //   name: 'Forgot password',
  //   align: 'left',
  //   route: {
  //     path: 'forgot-password',
  //     element: <ForgotPassword />,
  //   },
  // },
  // {
  //   name: 'Reset password',
  //   align: 'left',
  //   route: {
  //     path: 'reset-password/:secretKey',
  //     element: <ResetPassword />,
  //   },
  // },
  // {
  //   name: 'Confirm email',
  //   align: 'left',
  //   route: {
  //     path: 'complete-registration/:mode/:secretKey',
  //     element: <ConfirmEmail />,
  //   },
  // },
  // TODO: remove after
  /* for test */
  // {
  //   name: 'Confirm email (set a password)',
  //   align: 'left',
  //   route: {
  //     path: 'complete-registration-test/password/:secretKey',
  //     element: <ConfirmEmail mode="password" />,
  //   },
  // },
  /* * */
  // {
  //   name: 'Chat',
  //   align: 'left',
  //   route: {
  //     path: 'chat',
  //     element: <Chat />,
  //   },
  // },
  {
    name: 'Bookmarks',
    align: 'left',
    route: {
      path: 'bookmarks',
      element: <Bookmarks />,
    },
  },
  {
    name: 'SearchResults',
    ignoreMenu: true,
    align: 'left',
    route: {
      path: 'search-results',
      element: <SearchResults />,
    },
  },
  {
    name: 'SearchResults',
    ignoreMenu: true,
    align: 'left',
    route: {
      path: 'search-results/:id/:name',
      element: <SearchResults />,
    },
  },
  {
    name: 'Products',
    ignoreMenu: true,
    align: 'left',
    route: {
      path: 'product/:id/:name',
      element: <Products />,
    },
  },
  {
    name: 'Category',
    ignoreMenu: true,
    align: 'left',
    route: {
      path: 'category/:name/:id/:catName/:catId',
      element: <Category />,
    },
  },
  {
    name: 'SubCategory',
    ignoreMenu: true,
    align: 'left',
    route: {
      path: 'sub-category/:name/:id/:catName/:catId/:subName/:subId',
      element: <SubCategory />,
    },
  },
  {
    name: 'Article',
    ignoreMenu: true,
    align: 'left',
    route: {
      path: 'article/:name/:id/:artId',
      element: <Article />,
    },
  },
  {
    privateRoute: true,
    align: 'right',
    icon: <UserOutlined style={{ fontSize: 18 }} />,
    className: 'icon-padding-mini-sub',
    children: [
      {
        privateRoute: true,
        icon: <LogoutOutlined />,
        name: 'Sign out',
        onClick: () => {
          store.dispatch(signOut());
        },
      },
    ],
  },
];

export const paramsToString = (user?: User | null, params?: ((user: User) => string) | AnyObject | string) => {
  if (!user) {
    return '';
  }

  if (typeof params === 'string') {
    return '?params';
  }

  if (typeof params === 'function') {
    let result = params(user);

    if (result) {
      if (typeof result === 'object') {
        result = createSearchParams(result).toString();
      }

      return `?${result}`;
    }

    return '';
  }

  if (params && typeof params === 'object') {
    return `?${createSearchParams(params).toString()}`;
  }

  return '';
};

const createItem = ({
  route, children, ignoreMenu, privateRoute, ...data
}: Route, user: User) => {
  let childrenList;

  if (children && children.length > 0) {
    childrenList = children.filter(({ ignoreMenu: childrenIgnoreMenu }) => childrenIgnoreMenu !== true);

    if (childrenList.length > 0) {
      childrenList = childrenList.map(
        ({ ignoreMenu: childrenIgnoreMenu, privateRoute: childrenPrivateRoute, ...child }) => ({
          ...child,
          label: child.route ? (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            <NavLink to={`/${child.route.path}${paramsToString(user, child.route.path)}`}>
              {child.name || child.key}
            </NavLink>
          ) : (
            child.name
          ),
          key: child.route ? `/${child.route.path}` : `/${child.key || child.name}`,
        }),
      );
    }
  }

  const name = typeof data.name === 'function' ? data.name(user) : data.name;

  return {
    ...data,
    children: childrenList && childrenList.length > 0 ? childrenList : undefined,
    label: route ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      <NavLink to={`/${route.path}${paramsToString(user, route.params)}`}>{name}</NavLink>
    ) : (
      name
    ),
    key: route ? `/${route.path}` : `/${data.key || name}`,
  };
};

export const menuLeft = routes.filter(({ ignoreMenu }) => ignoreMenu !== true).filter(({ align }) => align === 'left');

export const menuRight = routes
  .filter(({ ignoreMenu }) => ignoreMenu !== true)
  .filter(({ align }) => align === 'right');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function filter(list: any[], user: User) {
  const newList = list.map((item) => ({ ...item, children: item.children ? [...item.children] : undefined }));

  return newList.filter((item) => {
    if (item && item.children && item.children.length > 0) {
      // eslint-disable-next-line no-param-reassign
      item.children = filter(item.children, user);
    }

    return item?.roles ? doesUserHaveAccess(item?.roles, user) : true;
  });
}

export interface MenuProps {
  user: User;
}

function Menu({ user }: MenuProps): React.ReactNode {
  const navigate = useNavigate();
  const { authorized } = useAuth();
  const { open, contextHolder } = useSimpleModal();
  const { pathname } = useLocation();
  const menuLeftFiltered = useMemo(
    () => filter(
      menuLeft.map((data) => createItem(data, user)),
      user,
    ).map((item) => ({
      ...item,
      name: typeof item.name === 'function' ? item.name(user) : item.name,
      icon: typeof item.icon === 'function' ? item.icon(user) : item.icon,
    })).map(({ children, ...item }) => item),
    [user],
  );
  const menuRightFiltered = useMemo(() => {
    const list = filter(
      menuRight.map((data) => createItem(data, user)),
      user,
    ).map((item) => ({
      ...item,
      name: typeof item.name === 'function' ? item.name(user) : item.name,
      icon: typeof item.icon === 'function' ? item.icon(user) : item.icon,
    }));

    if (list[2] && list[2].children && list[2].children[3]) {
      list[2].children[3].onClick = () => {
        open({
          icon: <LogoutOutlined style={{ color: '#FF4D4F' }} />,
          title: 'Log out',
          content: 'Are you sure you want to Log out?',
          cancelText: 'Cancel',
          centered: true,
          okText: 'Yes',
          onOk: () => {
            store.dispatch(signOut());
            navigate('/');
          },
        });
      };
    }

    return list;
  }, [user]);

  const activeMenuItem = `/${pathname.split('/')[1]}`;

  return (
    <div className={styles.menu}>
      <AntdMenu
        theme="light"
        mode="horizontal"
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        defaultSelectedKeys={[activeMenuItem]}
        selectedKeys={[activeMenuItem]}
        items={menuLeftFiltered}
        style={{ minWidth: 0, flex: 'auto' }}
      />
      <div style={{ justifyContent: 'end', paddingRight: 16, display: 'flex' }}>
        {authorized ? (
          <AntdMenu
            className={styles.rightMenu}
            theme="light"
            mode="horizontal"
            selectable={false}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            defaultSelectedKeys={[activeMenuItem]}
            selectedKeys={[activeMenuItem]}
            items={menuRightFiltered}
            style={{ minWidth: 0, flex: 'auto', justifyContent: 'end' }}
          />
        ) : 'not authorized'}
      </div>
      {contextHolder}
    </div>
  );
}

export default connect((state: RootState) => ({
  user: state[moduleName].user,
}))(Menu);
